module.exports = __webpack_public_path__ + "static/img/3.86c4fab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p6/3.png
// module id = CYhG
// module chunks = 1